<template>
    <div class="form-group mod">
        <label :for="id" class="form-label" :class="{ require: required }">
            {{ title }}
        </label>
        <div class="input-group remove-padding mod">
            <div v-if="prefix" class="input-group-prepend">
                <span class="input-group-text">{{ prefix }}</span>
            </div>
            <input
                v-if="visible"
                type="number"
                class="form-control"
                :placeholder="placeholder"
                autocomplete="off"
                :min="minValue"
                :max="maxValue"
                :step="steps"
                v-model="amount"
                :inputmode="inputMod"
                @blur="onBlurNumber"
                @input="doInput"
            />
            <input
                v-if="!visible"
                type="text"
                class="form-control"
                v-model="amount"
                :placeholder="placeholder"
                @focus="onFocusText"
            />
            <div v-if="suffix" class="input-group-prepend">
                <span class="input-group-text">{{ suffix }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SOInputNumber",
    props: {
        title: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        placeholder: String,
        required: Boolean,
        defaultValue: Number,
        maxValue: {
            type: Number,
            default: 999999999999,
        },
        minValue: {
            type: Number,
            default: 0,
        },

        disable: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },

        prefix: String,
        suffix: String,
        steps: {
            type: String,
            default: "1",
        },
        inputMod: {
            type: String,
            default: "numeric", //set decimal for comma
        },
    },
    data() {
        return {
            amount: this.defaultValue,
            visible: false,
            temp: this.defaultValue,
	        minValueTimeout: null
        };
    },
	watch: {
		amount: {
			handler: function () {
				clearTimeout(this.minValueTimeout)
				this.minValueTimeout = setTimeout(() => {
					if (this.minValue > 0) {
						if (Number(this.amount) < this.minValue) {
							this.amount = this.minValue.toString()
						}
					}
				}, 2000)
			},
			deep: true
		},
	},
    mounted() {},
    methods: {
        doInput() {
            this.$emit("input", this.amount);
        },
        setAmount(val) {
            this.amount = val;
            setTimeout(() => {
                this.onBlurNumber();
            }, 100);
        },
        onBlurNumber(e) {
            this.visible = false;
            this.temp = this.amount;
            this.amount = this.thousandSeprator(this.amount);
        },
        onFocusText() {
            this.visible = true;
            this.amount = this.temp;
        },
        thousandSeprator(amount) {
            if (amount !== "" || amount !== undefined || amount !== 0 || amount !== "0" || amount !== null) {
                return amount
                    .toString()
                    .replace(".", ",")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
                return amount;
            }
        },
    },
};
</script>
